import React, { useState, lazy, Suspense } from 'react';
import Navbar from './components/Navbar';
import Home from './components/Home';
import { DataProvider } from './context/DataContext';
import ScrollEarnings from './components/ScrollEarnings';
import './styles/App.css';
import Citations from './components/Citations';

// Lazy load components with charts
const WealthComparison = lazy(() => import('./components/WealthComparison'));
const BillionaireImpact = lazy(() => import('./components/BillionaireImpact'));
const LiveWealth = lazy(() => import('./components/LiveWealth'));
const Solutions = lazy(() => import('./components/Solutions'));

function App() {
  const [sharedSalary, setSharedSalary] = useState(50000);

  const handleSalaryChange = (newSalary) => {
    setSharedSalary(Number(newSalary) || 1);
  };

  return (
    <DataProvider>
      <div className="App">
        <Navbar />
        <main>
          <section id="home">
            <Home />
          </section>
          <Suspense fallback={<div className="loading-state">Loading impact data...</div>}>
            <section id="billionaire-impact">
              <BillionaireImpact />
            </section>
          </Suspense>
          <Suspense fallback={<div className="loading-state">Loading live wealth data...</div>}>
            <section id="live-wealth">
              <LiveWealth salary={sharedSalary} onSalaryChange={handleSalaryChange} />
            </section>
          </Suspense>
          <Suspense fallback={<div className="loading-state">Loading wealth comparison data...</div>}>
            <section id="wealth-comparison">
              <WealthComparison salary={sharedSalary} onSalaryChange={handleSalaryChange} />
            </section>
          </Suspense>
          <section id="support">
            <div className="support-section">
              <div className="support-content">
                <h3>Support This Project</h3>
                <p className="impact-message">
                  This site is maintained by a single developer committed to exposing wealth inequality through data visualization.
                </p>
                <a 
                  href="https://www.patreon.com/evandcoleman" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="support-button"
                  onClick={() => {
                    if (window.gtag) {
                      window.gtag('event', 'patreon_click', {
                        'event_category': 'Support',
                        'event_label': 'Support Button'
                      });
                    }
                  }}
                >
                  <span className="button-icon">❤️</span>
                  Support on Patreon
                </a>
                <p className="support-note">
                  Your support helps keep these tools free and accessible to everyone.
                  <br />
                  <span className="support-highlight">Together, we can make wealth inequality impossible to ignore.</span>
                </p>
              </div>
            </div>
          </section>
          <Suspense fallback={<div className="loading-state">Loading solutions...</div>}>
            <section id="solutions">
              <Solutions />
            </section>
          </Suspense>
          <section id="data-sources">
            <Citations />
          </section>
          <section id="scroll-earnings">
            <ScrollEarnings />
          </section>
        </main>
      </div>
    </DataProvider>
  );
}

export default App; 